import { ServiceCatalogItem, ServiceCatalogItemPayload } from '../../types';
import api from './client';

/**
 * A shop's repeatable services. Scoped server-side; `shopId` is only consulted
 * for super admins.
 */
export const serviceCatalogService = {
  list: async (options?: {
    activeOnly?: boolean;
    shopId?: string;
  }): Promise<ServiceCatalogItem[]> => {
    const response = await api.get<ServiceCatalogItem[]>('/service-catalog', {
      params: options,
    });
    return response.data;
  },
  create: async (
    payload: ServiceCatalogItemPayload,
    shopId?: string,
  ): Promise<ServiceCatalogItem> => {
    const response = await api.post<ServiceCatalogItem>('/service-catalog', payload, {
      params: shopId ? { shopId } : undefined,
    });
    return response.data;
  },
  update: async (
    id: string,
    payload: Partial<ServiceCatalogItemPayload>,
  ): Promise<ServiceCatalogItem> => {
    const response = await api.patch<ServiceCatalogItem>(
      `/service-catalog/${id}`,
      payload,
    );
    return response.data;
  },
  remove: async (id: string): Promise<void> => {
    await api.delete(`/service-catalog/${id}`);
  },
};
